<ng-template #content_custom_label_print_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.custom_label_print">
        <div class="side_popup_header">
            <span>{{localService.languageContent.custom_label_print.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 25) + 'px'}" *ngIf="item">
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.title" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" style="margin-bottom: 10px;" [readOnly]="!isCanEdit"
                        [(ngModel)]="item.title" title="{{localService.languageContent.custom_label_print.title}}"
                        id="{{elementIds.title}}"
                        placeholder="{{localService.languageContent.custom_label_print.title}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.disp_name" />
                </div>
                <div>
                    <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="item.displayName"
                        title="{{localService.languageContent.custom_label_print.disp_name}}"
                        id="{{elementIds.disp_name}}"
                        placeholder="{{localService.languageContent.custom_label_print.disp_name}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="item.isPinned" [disabled]="isLabelSelected" />
                    <span class="normal_color">{{isLabelSelected ?
                        localService.languageContent.custom_label_print.cant_edit:
                        localService.languageContent.custom_label_print.is_pinned}}</span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.custom_label_print.odr_nbr" />
                <input autocomplete="off" type="number" class="number" [ngClass]="item.orderNumber ? '' : 'en'"
                    title="{{localService.languageContent.custom_label_print.odr_nbr}}"
                    placeholder="{{localService.languageContent.custom_label_print.odr_nbr}}"
                    (keypress)="localService.isNumberOnly($event)" style="width:100px;"
                    [(ngModel)]="item.orderNumber" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.replace_label" />
                </div>
                <div style="width: calc(100% - 10px);">
                    <ngx-select *ngIf="replaceLabels.length > 0"
                        placeholder="{{localService.languageContent.custom_label_print.replace_label}}"
                        title="{{localService.languageContent.custom_label_print.replace_label}}"
                        [(ngModel)]="selectedReceiptReplaceLabel" [noAutoComplete]="false" [items]="replaceLabels"
                        [optionValueField]="'value'" [optionTextField]="'searchText'" [allowClear]="true"
                        (select)="onLabelSelected()" (remove)="onLabelSelected()">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div title="{{option.data.key}}" class="replace_option">
                                <span class="en ref_color"
                                    *ngIf="!(option.data.s_value && option.data.s_value.length > 0)">
                                    Ref:&nbsp;
                                </span>
                                <span>
                                    {{option.data.s_value && option.data.s_value.length > 0 ? option.data.s_value :
                                    option.data.key}}
                                </span>
                                <div class="en ref_color" *ngIf="option.data.s_value && option.data.s_value.length > 0">
                                    (Ref: {{option.data.key}})
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!selectedReceiptReplaceLabel || selectedReceiptReplaceLabel.length == 0">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.label" />
                </div>
                <div>
                    <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="item.label"
                        title="{{localService.languageContent.custom_label_print.label}}" id="{{elementIds.label}}"
                        placeholder="{{localService.languageContent.custom_label_print.label}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.map_value" />
                </div>
                <div style="width: calc(100% - 10px);">
                    <ngx-select *ngIf="receiptOptions.length > 0"
                        placeholder="{{localService.languageContent.custom_label_print.map_value}}"
                        title="{{localService.languageContent.custom_label_print.map_value}}"
                        [(ngModel)]="selectedReceiptOption" [noAutoComplete]="false" [items]="receiptOptions"
                        [optionValueField]="'key'" [optionTextField]="'value'" [allowClear]="true">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row"
            *ngIf="!(selectedReceiptOption && selectedReceiptOption == ReceiptOption.CustomField.toString())">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="item.isEditable" />
                    <span class="normal_color">{{localService.languageContent.custom_label_print.is_editable}}</span>
                </label>
            </div>
        </div>
        <div class="row"
            *ngIf="!(selectedReceiptOption && selectedReceiptOption == ReceiptOption.CustomField.toString())">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.custom_input_type" />
                </div>
                <div style="width: calc(100% - 10px);">
                    <ngx-select *ngIf="customLabelInputTypes.length > 0"
                        placeholder="{{localService.languageContent.custom_label_print.custom_input_type}}"
                        title="{{localService.languageContent.custom_label_print.custom_input_type}}"
                        [(ngModel)]="item.customLabelInputType" [noAutoComplete]="true" [items]="customLabelInputTypes"
                        [optionValueField]="'key'" [optionTextField]="'value'">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="selectedReceiptOption && selectedReceiptOption == ReceiptOption.CustomField.toString()">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.custom_field" />
                </div>
                <div style="width: calc(100% - 10px);">
                    <ngx-select *ngIf="customFields.length > 0"
                        placeholder="{{localService.languageContent.custom_label_print.custom_field}}"
                        title="{{localService.languageContent.custom_label_print.custom_field}}"
                        [(ngModel)]="item.value" [noAutoComplete]="true" [items]="customFields"
                        [optionValueField]="'s_value'" [optionTextField]="'value'" [allowClear]="true">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row"
            *ngIf="item.customLabelInputType == CustomLabelInputType.SingleSelect.toString() || item.customLabelInputType == CustomLabelInputType.MultiSelect.toString()">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.seperate_options" />
                </div>
                <div>
                    <textarea id="{{elementIds.value + '_opts_'}}" rows="5" [(ngModel)]="item.optionsValue"
                        title="{{localService.languageContent.custom_label_print.seperate_options}}"
                        placeholder="{{localService.languageContent.custom_label_print.seperate_options}}"></textarea>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="item.customLabelInputType != CustomLabelInputType.ImageUpload.toString()">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.value" />
                </div>
                <div>
                    <input
                        *ngIf="item.customLabelInputType == CustomLabelInputType.SingleInputBox.toString() || item.customLabelInputType == CustomLabelInputType.SingleSelect.toString()|| item.customLabelInputType == CustomLabelInputType.RadioButton.toString()"
                        autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="item.value"
                        title="{{localService.languageContent.custom_label_print.value}}" id="{{elementIds.value}}"
                        [readOnly]="selectedReceiptOption == ReceiptOption.CustomField.toString() || ((item.isAutoIncreaseValue || item.isValueCommonFoAllLanguage) && !isCanEdit)"
                        placeholder="{{localService.languageContent.custom_label_print.value}}" />
                    <textarea
                        *ngIf="!(item.customLabelInputType == CustomLabelInputType.SingleInputBox.toString() || item.customLabelInputType == CustomLabelInputType.SingleSelect.toString()|| item.customLabelInputType == CustomLabelInputType.RadioButton.toString())"
                        id="{{elementIds.value + '_mul_'}}" rows="5"
                        [readOnly]="(item.isAutoIncreaseValue || item.isValueCommonFoAllLanguage) && !isCanEdit"
                        [(ngModel)]="item.value" title="{{localService.languageContent.custom_label_print.value}}"
                        placeholder="{{localService.languageContent.custom_label_print.value}}"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.custom_label_print.group_by" />
                </div>
                <div>
                    <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="item.groupBy"
                        title="{{localService.languageContent.custom_label_print.group_by}}"
                        id="{{elementIds.group_by}}"
                        placeholder="{{localService.languageContent.custom_label_print.group_by}}" />
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!selectedReceiptOption || selectedReceiptOption == '0'">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="item.isAutoIncreaseValue" [disabled]="!isCanEdit" />
                    <span
                        class="normal_color">{{localService.languageContent.custom_label_print.is_auto_increase_value}}</span>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="!selectedReceiptOption || selectedReceiptOption == '0'">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="item.isValueCommonFoAllLanguage" [disabled]="!isCanEdit" />
                    <span
                        class="normal_color">{{localService.languageContent.custom_label_print.is_val_com_all_lang}}</span>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="!localService.isHideDummy">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="item.isPrintEmptyValue" />
                    <span class="normal_color">{{localService.languageContent.custom_label_print.is_print_empty}}</span>
                </label>
            </div>
        </div>
        <div class="box"
            *ngIf="selectedReceiptReplaceLabel && customStyles && customStyles.length > 0 && !localService.isHideDummy">
            <div class="row" *ngFor="let customStyle of customStyles">
                <div class="col-12">
                    <div *ngIf="customStyle.s_value === 'boolean'">
                        <label style="font-weight: normal; margin-left: 30px;">
                            <input type="checkbox" [(ngModel)]="customStyle.isSelected" />
                            <span
                                class="normal_color">{{localService.languageContent.custom_label_print[customStyle.key]}}</span>
                        </label>
                    </div>
                    <div *ngIf="customStyle.s_value === 'number'" style="margin-left: 15px;">
                        <app-label [Text]="localService.languageContent.custom_label_print[customStyle.key]" />
                        <input autocomplete="off" type="number" class="number" [ngClass]="customStyle.value ? '' : 'en'"
                            title="{{localService.languageContent.custom_label_print[customStyle.key]}}"
                            placeholder="{{localService.languageContent.custom_label_print[customStyle.key]}}"
                            (keypress)="localService.isNumberOnly($event, numericConfig)" style="width:100px;"
                            [(ngModel)]="customStyle.value" />
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="(!selectedReceiptReplaceLabel || selectedReceiptReplaceLabel.length == 0) && !localService.isHideDummy">
            <div class="row">
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.custom_label_print.margin_top" />
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.marginTop ? '' : 'en'"
                        title="{{localService.languageContent.custom_label_print.margin_top}}"
                        placeholder="{{localService.languageContent.custom_label_print.margin_top}}"
                        (keypress)="localService.isNumberOnly($event)" style="width:100px;"
                        [(ngModel)]="item.marginTop" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isTopPrint" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_top_print}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isTitleBold" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_ttl_bold}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isValueBold" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_val_bold}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isCenterAlign" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_center_align}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isColonRequired" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_colon_req}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isValueRightAlign" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_val_right_align}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="item.isTopLineRequired" />
                        <span
                            class="normal_color">{{localService.languageContent.custom_label_print.is_top_line_req}}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(1)">
                    {{id ? localService.languageContent.common.save : localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>